import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './RefundSelectorContainerContent.module.scss'

interface MoneyCashOptionProps {
	readonly selected: boolean
}

export function MoneyCashOption({ selected }: MoneyCashOptionProps) {
	const { t } = useLabels()

	return (
		<div data-testid='myRefunds.refundOptions.moneyCash.option'>
			<span className={cx(selected ? text.titleM : text.bodyM)}>
				{t('myRefunds.cash.title')}
			</span>
			<p className={`${styles.info} ${text.bodyM}`}>
				{t('myRefunds.cash.subtitle')}
			</p>
		</div>
	)
}
